import Service, { service } from '@ember/service';
import nameSort from 'scaleflow/utils/nameSort';

export default class UsersService extends Service {
  @service store;
  fetched = false;

  async getUsers() {
    if (!this.fetched) {
      return await this.loadUsers();
    } else {
      return this.convertToValueLabel(
        this.store
          .peekAll('person')
          .slice()
          .sort((a, b) => nameSort(a.name, b.name)),
      );
    }
  }

  getUsersSync() {
    return this.store
      .peekAll('person')
      .slice()
      .sort((a, b) => nameSort(a.name, b.name));
  }

  get userOptions() {
    return this.getUsersSync().map((item) => ({
      abbreviation: item.abbreviation,
      color: item.color,
      label: item.name,
      value: item.id,
      active: item.active,
    }));
  }

  convertToValueLabel(array) {
    return array.map((item) => {
      return {
        id: item.id,
        value: item.name,
        color: item.color,
        abbreviation: item.abbreviation,
        active: item.active,
      };
    });
  }

  async loadUsers() {
    const users = this.convertToValueLabel(
      (await this.store.query('person', {}))
        .slice()
        .sort((a, b) => nameSort(a.name, b.name)),
    );
    this.fetched = true;
    return users;
  }
}
